<template>
  <v-list v-if="booking">
    <text-list-item
      title="Cliente"
      :text="booking.client"
    />
    <text-list-item
      title="Correo Electrónico"
      :text="booking.email"
    />
    <text-list-item
      title="Teléfono"
      :text="booking.phone"
    />
    <text-list-item
      title="Evento"
      :text="booking.event"
    />
    <text-list-item
      title="Locación"
      :text="booking.location"
    />
    <text-list-item
      title="Precio"
      :text="price | currency"
    />
    <text-list-item
      v-if="paid"
      title="Pagado"
      :text="paid | currency"
    />
    <text-list-item
      v-if="toPay"
      title="Por Pagar"
      :text="toPay | currency"
    />
  </v-list>
</template>
<script>
import { computed } from '@vue/composition-api'
import TextListItem from '@/components/controls/TextListItem.vue'
import Calculations from '@/scripts/helpers/calculations'

export default {
  components: { TextListItem },
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { TotalPrice, TotalPaid, ToPay } = Calculations()
    const paid = computed(() => TotalPaid(props.booking))
    const toPay = computed(() => ToPay(props.booking))
    const price = computed(() => TotalPrice(props.booking))

    return {
      paid,
      toPay,
      price,
    }
  },
}
</script>
